import { Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";
import LinkComponent from "./LinkComponent";

export default function InfoTerms() {
	const { theme } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Typography
			fontSize={{ xs: 11, sm: 14 }}
			variant='body1'
			maxWidth={450}
			sx={{ mt: 2 }}
			color={theme?.colors.secondaryText}
		>
			{translate("customization.terms_1")}
			<LinkComponent
				title='customization.terms_2'
				link='https://www.vumi.io/terminos-y-condiciones'
			/>
			{translate("customization.terms_3")}
			<LinkComponent
				title='customization.terms_4'
				link='https://www.vumi.io/legal/politica-de-privacidad'
			/>
			{translate("customization.terms_5")}
		</Typography>
	);
}
